import { FC, ReactNode } from 'react'
import { Link, matchPath, useLocation } from 'react-router-dom'

export interface RouteLinkProps {
  route: string
  children: ReactNode
  onClick?: () => void
}

const RouteLink: FC<RouteLinkProps> = ({ route, children }) => {
  const location = useLocation()

  return (
    <Link
      className={
        matchPath(
          {
            path: route,
            end: false,
          },
          location.pathname
        )
          ? 'active'
          : ''
      }
      to={route}
    >
      {children}
    </Link>
  )
}

export default RouteLink
